import * as React from 'react'
import { Route, Switch } from 'react-router-dom'
import { IGlobalSettingsListState } from '../../types/global-settings'
import AccommodationsPane from '../../containers/global-settings/AccommodationsPane'
import AssistanceCategoryPane from './AssistanceCategoryPane'
import ColorPane from '../../containers/global-settings/ColorPane'
import GlobalSettingsList from './GlobalSettingsList'
import MakePane from '../../containers/global-settings/MakePane'
import MobilityCategoryPane from './MobilityCategoryPane'
import ServiceLevelPane from '../../containers/global-settings/ServiceLevelPane'
import ServiceProgramPane from './ServiceProgramPane'
import VehicleTypePane from '../../containers/global-settings/VehicleTypePane'
import ModelPane from '../../containers/global-settings/ModelPane'
import MobilityDevicesPane from './MobilityDevicesPane'
import AssistancePane from './AssistancePane'
import ErrorBoundary from '../ErrorBoundary'
import { getAccessJwtPayload } from 'src/utils/auth'
import { checkIfAdmin } from 'src/utils/authorization'

interface IGlobalSettingsPaneProps {
  settings: IGlobalSettingsListState
  getVehicleCreateOptions: () => Promise<any>
}

export default class GlobalSettingsPane extends React.Component<IGlobalSettingsPaneProps> {
  public componentDidMount() {
    this.props.getVehicleCreateOptions()
  }

  public render() {
    return (
      <ErrorBoundary>
        {this.isOrganizationAdmin() && (
          <Switch>
            <Route path='/global-settings/service-program' component={ServiceProgramPane} />
            <Route path='/global-settings/service-level' component={ServiceLevelPane} />
            <Route path='/global-settings/accommodations' component={AccommodationsPane} />
            <Route path='/global-settings/vehicle-type' component={VehicleTypePane} />
            <Route path='/global-settings/make' component={MakePane} />
            <Route path='/global-settings/color' component={ColorPane} />
            <Route path='/global-settings/mobility-category' component={MobilityCategoryPane} />
            <Route path='/global-settings/assistance-category' component={AssistanceCategoryPane} />
            <Route path='/global-settings/model' component={ModelPane} />
            <Route path='/global-settings/mobility-devices' component={MobilityDevicesPane} />
            <Route path='/global-settings/assistance' component={AssistancePane} />
            <Route component={GlobalSettingsList} />
          </Switch>
        )}

        {!this.isOrganizationAdmin() && (
          <div>
            <h2>{'Unauthorized'}</h2>
          </div>
        )}
      </ErrorBoundary>
    )
  }

  private isOrganizationAdmin() {
    return checkIfAdmin()
  }
}



// WEBPACK FOOTER //
// ./src/components/global-settings/GlobalSettingsPane.tsx